import type { ClientFormValues } from '../models/Forms';

export function toPersistedClientFormValues(values: ClientFormValues): ClientFormValues {
  const {
    identityDocumentValidationStatus: _identityDocumentValidationStatus,
    identityDocumentValidationFingerprint: _identityDocumentValidationFingerprint,
    ...persistedValues
  } = values;
  return persistedValues;
}
